import React from 'react'
import { Link } from 'react-router-dom';

function About() {
    return (
      <div className='container container-page container-about'>
        <div className='intro'>
          <h1 className='text-gradient'>Hello.</h1>
          <p>Thank you for visiting. On this site, you'll find a catalog of photos I've taken, projects I've worked on, and places I've been. Friends can dive a little deeper by heading <Link to={"/login"}>here</Link>.</p>

          <h5>About Me</h5>
          <p><b>I'm a software engineer and digital designer based in Brooklyn, NY.</b> </p>
          <h5>About this site</h5>
          <p>Part of the fun of building this site was trying to do everything from scratch. Other than enlisting the help of a few libraries (Twilio, Google Maps, and OpenCV to name a few), most of the design and coding was done from scratch.</p>
        </div>
      </div>
    );
  }

export default About;